import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";

const LOGO =
  "https://customer-assets.emergentagent.com/job_web-instructions-3/artifacts/3j0ga580_Milet%20%2830%29.png";

const links = [
  { to: "/", label: "Home" },
  { to: "/what-is-millet", label: "The OG Supergrain" },
  { to: "/why-millets", label: "Millets Vs Everything" },
  { to: "/blog", label: "Journal" },
];

export default function Navbar() {
  const [open, setOpen] = React.useState(false);

  return (
    <header
      data-testid="site-navbar"
      className="fixed inset-x-0 top-0 z-50 border-b-2 border-jet bg-cream"
    >
      <div className="mx-auto flex h-[104px] max-w-[1500px] items-center justify-between gap-4 px-5 md:h-[128px] md:px-8">
        {/* LEFT cluster: logo + join drop button */}
        <div className="flex items-center gap-4 md:gap-6">
          <Link
            to="/"
            data-testid="nav-logo-link"
            className="flex shrink-0 items-center"
            aria-label="Milet home"
          >
            <img
              src={LOGO}
              alt="Milet"
              className="h-[80px] w-auto md:h-[112px]"
              draggable={false}
            />
          </Link>
          <Link
            to="/#newsletter"
            data-testid="nav-newsletter-btn"
            className="hidden items-center gap-1.5 rounded-full border-2 border-jet bg-cobalt px-4 py-2 font-sans text-xs font-extrabold uppercase tracking-[0.12em] text-cream transition hover:bg-orange lg:inline-flex"
            style={{ boxShadow: "3px 3px 0 #0B0B0F" }}
          >
            Join the drop
            <ArrowUpRight size={14} strokeWidth={2.8} />
          </Link>
        </div>

        {/* RIGHT: nav links */}
        <nav className="hidden items-center gap-8 md:flex">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `relative font-sans text-[13px] font-extrabold uppercase tracking-[0.1em] transition after:absolute after:-bottom-1.5 after:left-0 after:h-[3px] after:rounded-full after:bg-cobalt after:transition-all ${
                  isActive
                    ? "text-cobalt after:w-full"
                    : "text-jet after:w-0 hover:text-pink"
                }`
              }
              end={l.to === "/"}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        {/* MOBILE toggle */}
        <button
          data-testid="nav-mobile-toggle"
          className="rounded-full border-2 border-jet bg-cream p-2.5 transition hover:bg-butter md:hidden"
          style={{ boxShadow: "3px 3px 0 #0B0B0F" }}
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {/* MOBILE sheet */}
      {open && (
        <div className="border-t-2 border-jet bg-cream px-5 py-5 md:hidden">
          <div className="flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `border-b-2 border-jet/10 py-3 font-sans text-sm font-extrabold uppercase tracking-[0.1em] ${
                    isActive ? "text-cobalt" : "text-jet"
                  }`
                }
                end={l.to === "/"}
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/#newsletter"
              data-testid="nav-mobile-newsletter-btn"
              onClick={() => setOpen(false)}
              className="mt-4 inline-flex items-center justify-center gap-1.5 rounded-full border-2 border-jet bg-cobalt px-5 py-3 font-sans text-xs font-extrabold uppercase tracking-[0.12em] text-cream"
              style={{ boxShadow: "4px 4px 0 #0B0B0F" }}
            >
              Join the drop <ArrowUpRight size={14} strokeWidth={2.8} />
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
